// generateDummyNewStreaks.js
// FIXED — corrected 'srreakFromDate' typo → 'streakFromDate'

export const generateDummyNewStreaks = (user) => {
    if (!user) return [];

    const base = [
        { streakType: "LOGIN",       title: "Login Streak Bonus",   points: 5,  emoji: "⚡" },
        { streakType: "DAILY",       title: "Daily Activity Streak", points: 8,  emoji: "🔥" },
        { streakType: "WIN",         title: "Win Streak Reward",    points: 20, emoji: "🏆" },
        { streakType: "CONSISTENCY", title: "Consistency Bonus",    points: 15, emoji: "🔁" },
    ];

    const modules = ["PurpleDoor", "PurpleDoor", "PurpleDoor", "LifeReplay", "Others"];
    const getRandModule = () => modules[Math.floor(Math.random() * modules.length)];

    return base.map((b, i) => ({
        _id:          `${user._id}-${i}`,
        userId:       user._id,
        userName:     user.name,
        userCode:     user.think5whyscode,
        particulars:  `${b.emoji} ${b.title}`,
        streakModule: getRandModule(),
        streakType:   b.streakType,
        points:       b.points,
        streakFromDate: new Date(), // FIX: was 'srreakFromDate'
        streakToDate:   new Date(),
        streakBankDate: new Date(),
        inOutType:    "In",
        balance:      b.points,
        remarks:      "Generated by streak engine (demo)",
    }));
};
